module.exports = __webpack_public_path__ + "static/media/h5_apply_drawing.a94465d1.png";